import { render, staticRenderFns } from "./ComplaintTakeActionChecklistCard.vue?vue&type=template&id=19828980&scoped=true"
import script from "./ComplaintTakeActionChecklistCard.vue?vue&type=script&lang=js"
export * from "./ComplaintTakeActionChecklistCard.vue?vue&type=script&lang=js"
import style0 from "./ComplaintTakeActionChecklistCard.vue?vue&type=style&index=0&id=19828980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19828980",
  null
  
)

export default component.exports